export default {
  changeDate: null,
  arrowClick: false
}
